import React from 'react';
import './TextSizeSwitch.css'
import useLocalStorage from "../hooks";

export const TextSizeSwitch = () => {
    const [textSize, setTextSize] = useLocalStorage('text.size', '');

    const enlargeTextSize = (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.documentElement.classList.add('textsize-large');
        setTextSize('textsize-large');
    }

    const reduceTextSize = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if(document.documentElement.classList) {
            document.documentElement.classList.remove('textsize-large');
        }
        setTextSize('');
    }

    return (
        <div className="textsize-switch" style={{fontFamily: 'serif', display: 'inline-block'}}>
            <button onClick={reduceTextSize} style={{marginRight: '15px', marginLeft: '25px'}}><span className="switch-small" style={{fontSize: 'var(--font-size-large)', cursor: 'pointer', fontWeight: 'normal'}}>A</span></button>
            <button onClick={enlargeTextSize}><span className="switch-large" style={{fontSize: 'var(--font-size-largest)', cursor: 'pointer', fontWeight: 'normal'}}>A</span></button>
        </div>
    );
};
